//import node module libraries
import { useContext } from "react";
import { AccordionContext, useAccordionButton } from "react-bootstrap";
import { Link } from "react-router-dom";

interface CustomToggleProps {
  children: React.ReactNode;
  eventKey: any;
  isActive?: boolean;
}

export const CustomToggleLevelTwo: React.FC<CustomToggleProps> = ({
  children,
  eventKey,
  isActive,
}) => {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey);
  const isCurrentEventKey = Array.isArray(activeEventKey)
    ? activeEventKey.includes(eventKey)
    : activeEventKey === eventKey;
  return (
    <Link
      to="#"
      className={`nav-link${isActive ? " active" : ""}`}
      onClick={decoratedOnClick}
      data-bs-toggle="collapse"
      data-bs-target="#navDashboard"
      aria-expanded={isCurrentEventKey}
      aria-controls="navDashboard"
    >
      {children}
    </Link>
  );
};
